import { OnboardingQuestion, Language } from '../types';

// ========================================
// SPEED QUESTIONNAIRE - Deep Discovery (5 Questions)
// ========================================

export const ONBOARDING_QUESTIONS: Record<Language, OnboardingQuestion[]> = {
  Italian: [
    {
      id: 'q1_authentic_moment',
      question: 'Racconta un momento in cui ti sei sentito davvero TE STESSO',
      placeholder: 'Es: "Quando stavo lavorando su quel progetto personale fino a tardi, completamente immerso..."',
      type: 'long_text',
      purpose: 'Identifies core values and authentic self',
      minLength: 50
    },
    {
      id: 'q2_morning_motivation',
      question: 'Quando ti svegli, quale pensiero ti motiva ad alzarti?',
      placeholder: 'Es: "Voglio creare qualcosa di mio, lasciare un segno..."',
      type: 'long_text',
      purpose: 'Discovers intrinsic goals and drivers',
      minLength: 30
    },
    {
      id: 'q3_current_frustration',
      question: 'Cosa ti frustra di più nella tua vita attuale?',
      placeholder: 'Es: "Mi sento intrappolato in una routine che non mi rappresenta..."',
      type: 'long_text',
      purpose: 'Identifies blockers and misalignments',
      minLength: 40
    },
    {
      id: 'q4_unlimited_resources',
      question: 'Se avessi tempo e soldi illimitati, cosa faresti?',
      placeholder: 'Es: "Viaggerei, scriverei un libro, passerei più tempo con la famiglia..."',
      type: 'long_text',
      purpose: 'Uncovers true aspirations',
      minLength: 40
    },
    {
      id: 'q5_ideal_day',
      question: 'Descrivi la tua giornata ideale, dal risveglio alla sera',
      placeholder: 'Es: "Mi sveglio presto, faccio yoga, lavoro su progetti che mi appassionano..."',
      type: 'long_text',
      purpose: 'Reveals lifestyle goals and priorities',
      minLength: 60
    }
  ],
  English: [
    {
      id: 'q1_authentic_moment',
      question: 'Tell me about a moment when you felt truly YOURSELF',
      placeholder: 'E.g., "When I was working on that personal project late at night, completely immersed..."',
      type: 'long_text',
      purpose: 'Identifies core values and authentic self',
      minLength: 50
    },
    {
      id: 'q2_morning_motivation',
      question: 'When you wake up, what thought motivates you to get out of bed?',
      placeholder: 'E.g., "I want to create something of my own, leave a mark..."',
      type: 'long_text',
      purpose: 'Discovers intrinsic goals and drivers',
      minLength: 30
    },
    {
      id: 'q3_current_frustration',
      question: 'What frustrates you most about your current life?',
      placeholder: 'E.g., "I feel trapped in a routine that doesn\'t represent who I am..."',
      type: 'long_text',
      purpose: 'Identifies blockers and misalignments',
      minLength: 40
    },
    {
      id: 'q4_unlimited_resources',
      question: 'If you had unlimited time and money, what would you do?',
      placeholder: 'E.g., "I\'d travel, write a book, spend more time with family..."',
      type: 'long_text',
      purpose: 'Uncovers true aspirations',
      minLength: 40
    },
    {
      id: 'q5_ideal_day',
      question: 'Describe your ideal day, from when you wake up to evening',
      placeholder: 'E.g., "I wake up early, do yoga, work on projects I\'m passionate about..."',
      type: 'long_text',
      purpose: 'Reveals lifestyle goals and priorities',
      minLength: 60
    }
  ],
  Spanish: [
    {
      id: 'q1_authentic_moment',
      question: 'Cuéntame sobre un momento en que te sentiste verdaderamente TÚ MISMO',
      placeholder: 'Ej: "Cuando estaba trabajando en ese proyecto personal hasta tarde, completamente inmerso..."',
      type: 'long_text',
      purpose: 'Identifies core values and authentic self',
      minLength: 50
    },
    {
      id: 'q2_morning_motivation',
      question: 'Cuando te despiertas, ¿qué pensamiento te motiva a levantarte?',
      placeholder: 'Ej: "Quiero crear algo propio, dejar huella..."',
      type: 'long_text',
      purpose: 'Discovers intrinsic goals and drivers',
      minLength: 30
    },
    {
      id: 'q3_current_frustration',
      question: '¿Qué te frustra más de tu vida actual?',
      placeholder: 'Ej: "Me siento atrapado en una rutina que no me representa..."',
      type: 'long_text',
      purpose: 'Identifies blockers and misalignments',
      minLength: 40
    },
    {
      id: 'q4_unlimited_resources',
      question: 'Si tuvieras tiempo y dinero ilimitados, ¿qué harías?',
      placeholder: 'Ej: "Viajaría, escribiría un libro, pasaría más tiempo con la familia..."',
      type: 'long_text',
      purpose: 'Uncovers true aspirations',
      minLength: 40
    },
    {
      id: 'q5_ideal_day',
      question: 'Describe tu día ideal, desde que te despiertas hasta la noche',
      placeholder: 'Ej: "Me despierto temprano, hago yoga, trabajo en proyectos que me apasionan..."',
      type: 'long_text',
      purpose: 'Reveals lifestyle goals and priorities',
      minLength: 60
    }
  ],
  German: [
    {
      id: 'q1_authentic_moment',
      question: 'Erzähl mir von einem Moment, in dem du dich wirklich DU SELBST gefühlt hast',
      placeholder: 'Z.B.: "Als ich spät nachts an diesem persönlichen Projekt arbeitete, völlig vertieft..."',
      type: 'long_text',
      purpose: 'Identifies core values and authentic self',
      minLength: 50
    },
    {
      id: 'q2_morning_motivation',
      question: 'Wenn du aufwachst, welcher Gedanke motiviert dich aufzustehen?',
      placeholder: 'Z.B.: "Ich will etwas Eigenes schaffen, Spuren hinterlassen..."',
      type: 'long_text',
      purpose: 'Discovers intrinsic goals and drivers',
      minLength: 30
    },
    {
      id: 'q3_current_frustration',
      question: 'Was frustriert dich am meisten in deinem aktuellen Leben?',
      placeholder: 'Z.B.: "Ich fühle mich in einer Routine gefangen, die nicht zu mir passt..."',
      type: 'long_text',
      purpose: 'Identifies blockers and misalignments',
      minLength: 40
    },
    {
      id: 'q4_unlimited_resources',
      question: 'Wenn du unbegrenzt Zeit und Geld hättest, was würdest du tun?',
      placeholder: 'Z.B.: "Ich würde reisen, ein Buch schreiben, mehr Zeit mit der Familie verbringen..."',
      type: 'long_text',
      purpose: 'Uncovers true aspirations',
      minLength: 40
    },
    {
      id: 'q5_ideal_day',
      question: 'Beschreibe deinen idealen Tag, vom Aufwachen bis zum Abend',
      placeholder: 'Z.B.: "Ich wache früh auf, mache Yoga, arbeite an Projekten, die mich begeistern..."',
      type: 'long_text',
      purpose: 'Reveals lifestyle goals and priorities',
      minLength: 60
    }
  ],
  French: [
    {
      id: 'q1_authentic_moment',
      question: 'Parle-moi d\'un moment où tu t\'es senti vraiment TOI-MÊME',
      placeholder: 'Ex: "Quand je travaillais sur ce projet personnel tard le soir, complètement absorbé..."',
      type: 'long_text',
      purpose: 'Identifies core values and authentic self',
      minLength: 50
    },
    {
      id: 'q2_morning_motivation',
      question: 'Quand tu te réveilles, quelle pensée te motive à te lever?',
      placeholder: 'Ex: "Je veux créer quelque chose qui m\'appartient, laisser une trace..."',
      type: 'long_text',
      purpose: 'Discovers intrinsic goals and drivers',
      minLength: 30
    },
    {
      id: 'q3_current_frustration',
      question: 'Qu\'est-ce qui te frustre le plus dans ta vie actuelle?',
      placeholder: 'Ex: "Je me sens piégé dans une routine qui ne me représente pas..."',
      type: 'long_text',
      purpose: 'Identifies blockers and misalignments',
      minLength: 40
    },
    {
      id: 'q4_unlimited_resources',
      question: 'Si tu avais un temps et de l\'argent illimités, que ferais-tu?',
      placeholder: 'Ex: "Je voyagerais, j\'écrirais un livre, passerais plus de temps avec ma famille..."',
      type: 'long_text',
      purpose: 'Uncovers true aspirations',
      minLength: 40
    },
    {
      id: 'q5_ideal_day',
      question: 'Décris ta journée idéale, du réveil au soir',
      placeholder: 'Ex: "Je me réveille tôt, fais du yoga, travaille sur des projets qui me passionnent..."',
      type: 'long_text',
      purpose: 'Reveals lifestyle goals and priorities',
      minLength: 60
    }
  ]
};

// ========================================
// BULK UPLOAD STRINGS
// ========================================

export const BULK_UPLOAD_STRINGS: Record<Language, {
  title: string;
  subtitle: string;
  photoTitle: string;
  photoDesc: string;
  skip: string;
  upload: string;
  processing: string;
  success: string;
  selectPhotos: string;
  uploaded: string;
}> = {
  Italian: {
    title: 'Vuoi mostrarmi qualcosa di te?',
    subtitle: 'Le foto raccontano chi sei meglio di mille parole. Momenti felici, luoghi del cuore, persone care - tutto mi aiuta a conoscerti davvero.',
    photoTitle: 'Carica delle foto',
    photoDesc: 'Foto che ti rappresentano: viaggi, persone, momenti speciali',
    skip: 'Per ora no, grazie',
    upload: 'Analizza le mie foto',
    processing: 'Sto guardando i tuoi ricordi...',
    success: 'Ho trovato {moments} momenti significativi nelle tue foto',
    selectPhotos: 'Scegli le foto',
    uploaded: '{count} foto pronte'
  },
  English: {
    title: 'Want to show me something about you?',
    subtitle: 'Photos tell who you are better than a thousand words. Happy moments, beloved places, dear people - everything helps me truly know you.',
    photoTitle: 'Upload some photos',
    photoDesc: 'Photos that represent you: trips, people, special moments',
    skip: 'Not right now, thanks',
    upload: 'Analyze my photos',
    processing: 'Looking at your memories...',
    success: 'Found {moments} meaningful moments in your photos',
    selectPhotos: 'Choose photos',
    uploaded: '{count} photos ready'
  },
  Spanish: {
    title: '¿Quieres mostrarme algo de ti?',
    subtitle: 'Las fotos cuentan quién eres mejor que mil palabras. Momentos felices, lugares queridos, personas amadas - todo me ayuda a conocerte de verdad.',
    photoTitle: 'Sube algunas fotos',
    photoDesc: 'Fotos que te representan: viajes, personas, momentos especiales',
    skip: 'Ahora no, gracias',
    upload: 'Analiza mis fotos',
    processing: 'Mirando tus recuerdos...',
    success: 'Encontré {moments} momentos significativos en tus fotos',
    selectPhotos: 'Elige fotos',
    uploaded: '{count} fotos listas'
  },
  German: {
    title: 'Willst du mir etwas von dir zeigen?',
    subtitle: 'Fotos erzählen, wer du bist, besser als tausend Worte. Glückliche Momente, geliebte Orte, liebe Menschen - alles hilft mir, dich wirklich zu kennen.',
    photoTitle: 'Lade ein paar Fotos hoch',
    photoDesc: 'Fotos, die dich repräsentieren: Reisen, Menschen, besondere Momente',
    skip: 'Jetzt nicht, danke',
    upload: 'Analysiere meine Fotos',
    processing: 'Schaue mir deine Erinnerungen an...',
    success: '{moments} bedeutungsvolle Momente in deinen Fotos gefunden',
    selectPhotos: 'Fotos auswählen',
    uploaded: '{count} Fotos bereit'
  },
  French: {
    title: 'Veux-tu me montrer quelque chose de toi?',
    subtitle: 'Les photos racontent qui tu es mieux que mille mots. Moments heureux, lieux chers, personnes aimées - tout m\'aide à vraiment te connaître.',
    photoTitle: 'Charge quelques photos',
    photoDesc: 'Photos qui te représentent: voyages, personnes, moments spéciaux',
    skip: 'Pas maintenant, merci',
    upload: 'Analyse mes photos',
    processing: 'Je regarde tes souvenirs...',
    success: 'Trouvé {moments} moments significatifs dans tes photos',
    selectPhotos: 'Choisir des photos',
    uploaded: '{count} photos prêtes'
  }
};
